import React, { useState } from 'react';
import { TextField, Typography, Box, Grid } from '@mui/material';
import BaseModal from './BaseModal';

const DateRangeModal = ({ open, onClose, onSubmit, loading, reportType }) => {
  const [filters, setFilters] = useState({
    dateRange: {
      startDate: null,
      endDate: null,
    },
  });

  const handleDateChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      dateRange: {
        ...prev.dateRange,
        [field]: value,
      },
    }));
  };

  const handleSubmit = () => {
    const payload = {
      startDate: filters.dateRange.startDate,
      endDate: filters.dateRange.endDate,
    };

    onSubmit(payload);
  };

  const handleClose = () => {
    setFilters({
      dateRange: {
        startDate: null,
        endDate: null,
      },
    });
    onClose();
  };

  const isSubmitDisabled = !filters.dateRange.startDate || !filters.dateRange.endDate;

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      loading={loading}
      reportType={reportType}
      submitDisabled={isSubmitDisabled}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, color: 'text.primary', fontWeight: 600 }}>
          Select Date Range
        </Typography>

        <Grid container spacing={3}>
          {/* Start Date */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Start Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.startDate || ''}
              onChange={(e) => handleDateChange('startDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>

          {/* End Date */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              End Date *
            </Typography>
            <TextField
              type="date"
              fullWidth
              size="small"
              value={filters.dateRange.endDate || ''}
              onChange={(e) => handleDateChange('endDate', e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1.5,
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </BaseModal>
  );
};

export default DateRangeModal;
